// ============================================================
// shopStatus.js
// The fabrication status of a SHOP DRAWING, and the one write that sets it.
//
// Two screens change this now: the shop tablet (/shop), where the welders move
// a drawing through the day, and the office list and editor (/shop-drawings),
// where an admin occasionally corrects it. Both write the SAME three fields
// through shopStatusFields below, so the two can never drift — the same reason
// pickStatusFields exists in pickStatus.js.
//
// KEY vs LABEL — they deliberately differ. The KEY is what is STORED; the label
// is only what a screen says, and each screen owns its own styling. 'Pending' is
// stored and reads as "Submitted". Renaming a key would mean migrating every
// record already written, so the stored vocabulary is frozen.
// ============================================================

/** The stored statuses, in the order a drawing moves through them. */
export const SHOP_STATUS_KEYS = ['Pending', 'In Progress', 'Complete'];

/** The status a drawing with no stored value — every older one — reads as. */
export const DEFAULT_SHOP_STATUS = 'Pending';

/** Is this one of the stored statuses? Guards a write against a stray value. */
export const isShopStatus = (status) => SHOP_STATUS_KEYS.includes(status);

/** This drawing's status, with the fallback applied. */
export const resolveShopStatus = (drawing) =>
  (isShopStatus(drawing?.shopStatus) ? drawing.shopStatus : DEFAULT_SHOP_STATUS);

/**
 * The fields written when ANYONE changes a drawing's shop status.
 *
 * `displayName` is whoever made the change — the welder on the tablet or the
 * admin in the office. It is stored as shopStatusBy precisely so the shop can
 * see that the office moved it, rather than wondering who did.
 */
export const shopStatusFields = (displayName, status) => ({
  shopStatus: status,
  shopStatusBy: displayName || '',
  shopStatusAt: new Date().toISOString(),
});
